exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carts-date-filter{display:flex;justify-content:space-between}.carts-date-filter #date-picker-container{top:0}.carts-date-filter #date-picker-container>div{position:relative;top:0}.carts-date-filter #cart-daterange{background:var(--white);width:10rem;margin-right:.75rem;color:var(--text-dark)}.carts-date-filter #cart-daterange svg{font-size:.875rem}.carts-date-filter #cart-daterange *{font-size:.75rem;font-weight:400}.carts-date-filter #cart-daterange>div:first-of-type{border:1px solid var(--border);border-radius:.25rem}", ""]);

// exports
